import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-notification-icon',
  imports: [NgClass],
  templateUrl: './notification-icon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notification-icon.scss',
})
export class NotificationIcon {
  @Input() public notificationCount = 0;
}
